<template>
    <v-menu 
        v-model="doShowColorDropdown" 
        top nudge-bottom="105" nudge-left="16"
        :close-on-content-click="false"
    >
        <template v-slot:activator="{ on }">
            <div class="q-color-input">
                <input v-model="color" class="q-color-input__input" />
                <div class="q-color-input__color-wrapper" v-on="on">
                    <div class="q-color-input__color" :style="switchStyle" />
                    <v-icon
                        v-if="pallet"
                        class="ml-2" 
                        :color="color"
                        @click.stop="$emit('click:pallet')"
                    >
                        fas fa-swatchbook
                    </v-icon> 
                </div>              
            </div>
        </template>
        <v-card>
            <v-card-text class="pa-0">
                <v-color-picker v-model="color" flat />
            </v-card-text>
        </v-card>
    </v-menu>
</template>

<script>
export default {
    props: {
        value: { type: String },
        pallet: { type: Boolean },
    },

    data() {
        return {
            doShowColorDropdown: false,
        };
    },

    computed: {
        color: {
            get() { return this.$props.value },
            set(v) { this.$emit('input', v) }
        },
        switchStyle() {
            return {
                backgroundColor: this.color,
            }
        }
    },
};
</script>

<style lang="scss" scoped>
.q-color-input {
    display: inline-flex;
    border: 2px solid rgba(2, 2, 2, 0.1);
    border-radius: 4px;

    &__color {
        $size: 18px;
        height: $size;
        width: $size;
        border: 2px solid rgba(127, 127, 127, 0.251);
        cursor: 'pointer';

        &-wrapper {
            background-color: rgba(7, 7, 7, 0.05);
            padding: 8px;
            display: flex;
            align-items: center;
            cursor: pointer;
        }
    }

    &__input {
        width: 120px;
        outline: none;
        padding: 4px 8px;
    }
}
</style>